import { EMPTY_RECAL_PROCESS_AND_GEN_EDIT_CRITERIA } from "domain/entity/Recalculation/RecalProcessAndGenEditCriteria";
import { RecalProcessAndGenEntity } from "domain/entity/Recalculation/RecalProcessAndGenEntity";
import { EMPTY_RECAL_PROCESS_AND_GEN_GENERATE_CRITERIA, RecalProcessAndGenGenerateCriteria } from "domain/entity/Recalculation/RecalProcessAndGenGenerateCriteria";
import { EMPTY_RECAL_PROCESS_AND_GEN_SEARCH_CRITERIA, RecalProcessAndGenSearchCriteria } from "domain/entity/Recalculation/RecalProcessAndGenSearchCriteria";
import { RecalProcessAndGenSubmitEntity } from "domain/entity/Recalculation/RecalProcessAndGenSubmitEntity";
import { ChargeTypeRepository } from "domain/repository/ChargeType/ChargeTypeRepo";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { CustomerRepository } from "domain/repository/Company/CustomerRepo";
import { RecalProcessAndGenRepository } from "domain/repository/Recalculation/RecalProcessAndGenRepo";
import { RecalProposalSetRepository } from "domain/repository/RecalProposalSet/RecalProposalSetRepo";
import { StandardTariffCodeRepository } from "domain/repository/TariffCode/StandardTariffCodeRepo";
import { TariffTypeRepository } from "domain/repository/TariffCode/TariffTypeRepo";
import _ from "lodash";
import { DropdownProps } from "presentation/model/DropdownProps";
import { RecalProcessAndGenMaintenanceModel } from "presentation/model/Recalculation/RecalProcessAndGenMaintenanceModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface RecalProcessAndGenVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<RecalProcessAndGenMaintenanceModel>> | ((value: SetStateAction<RecalProcessAndGenMaintenanceModel>) => void),
    ],
    recalProcessAndGenRepo: RecalProcessAndGenRepository,
    companyRepo: CompanyRepository,
    chargeTypeRepo: ChargeTypeRepository,
    tariffTypeRepo: TariffTypeRepository,
    standardTariffCodeRepo: StandardTariffCodeRepository,
    recalProposalSetRepo: RecalProposalSetRepository,
    customerRepo: CustomerRepository,
}

export const RecalProcessAndGenVM = ({ dispatch, recalProcessAndGenRepo, companyRepo, chargeTypeRepo, tariffTypeRepo, customerRepo,
    standardTariffCodeRepo, recalProposalSetRepo }: RecalProcessAndGenVMProps) => {
    const [recalProcessAndGenDispatch] = dispatch;

    const loadDropdownOption = async () => {

        await standardTariffCodeRepo.getAllStandardTariffCodes().then(
            tariffs => {

                let newTariffs = _.orderBy(tariffs, ["tariffType", "tariffCode"]);
                let tariffTypeDropdownOptions: DropdownProps[] = [];
                let tariffCodeDropdownOptions: { [key: string]: DropdownProps[] } = {};
                let allTariffCodeeDropdownOptions: DropdownProps[] = [];

                newTariffs?.forEach(tariff => {
                    const isTariffTypeExisted = tariffTypeDropdownOptions?.find(t =>
                        t.value === tariff.tariffType);
                    if (!isTariffTypeExisted) {
                        tariffTypeDropdownOptions.push({
                            dropdownLabel: tariff.tariffType,
                            tagLabel: tariff.tariffType,
                            value: tariff.tariffType,
                        })
                    }

                    const isTariffCodeExisted = allTariffCodeeDropdownOptions?.find(t =>
                        t.value === tariff.tariffCode);

                    if (!isTariffCodeExisted) {
                        allTariffCodeeDropdownOptions.push({
                            dropdownLabel: tariff.tariffCode,
                            tagLabel: tariff.tariffCode,
                            value: tariff.tariffCode,
                        })
                    }

                    if (tariff.tariffCode) {
                        if (!tariffCodeDropdownOptions[tariff.tariffType]) {
                            tariffCodeDropdownOptions[tariff.tariffType] = [];
                        }
                        tariffCodeDropdownOptions[tariff.tariffType].push({
                            dropdownLabel: tariff.tariffCode,
                            tagLabel: tariff.tariffCode,
                            value: tariff.tariffCode,
                        })

                    }
                })

                recalProcessAndGenDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        // tariffTypeDropdownOptions: tariffTypeDropdownOptions,
                        tariffCodeDropdownOptions: tariffCodeDropdownOptions,
                    }
                }))
            }
        )

        await customerRepo.getCustomerActive().then(
            customers => {
                let customerCodeDropdownOptions = customers?.map((customer) => ({
                    dropdownLabel: customer.customerCode + ' ' + customer.customerDesc1,
                    tagLabel: customer.customerCode,
                    value: customer.customerCode,
                })) ?? []
                customerCodeDropdownOptions = _.orderBy(customerCodeDropdownOptions, "dropdownLabel");

                recalProcessAndGenDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        customerCodeDropdownOptions: customerCodeDropdownOptions,
                    }
                }))
            }
        )

        await tariffTypeRepo.getAllActiveTariffTypes().then(
            tariffs => {
                let newTariffs = _.orderBy(tariffs, ["tariffType"]);
                let tariffTypeDropdownOptions = newTariffs?.map((entity) => ({
                    dropdownLabel: entity.tariffType,
                    tagLabel: entity.tariffType,
                    value: entity.tariffType,
                })) ?? []

                recalProcessAndGenDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        tariffTypeDropdownOptions: tariffTypeDropdownOptions,
                    }
                }))
            }
        )

        await chargeTypeRepo.getAllChargeTypesForCombobox().then(
            chargeTypes => {
                let newChargeTypeList = _.orderBy(chargeTypes, ["chargeType", "subChargeType"]);
                //let newChargeTypes = newChargeTypeList.filter(entity => entity.chargeCategory === 'GEN' || entity.chargeCategory === 'SYS');

                let chargeTypeDropdownOption: DropdownProps[] = [];
                let subChargeTypeDropdownOption: { [key: string]: DropdownProps[] } = {};
                newChargeTypeList?.forEach(chgTypeEty => {
                    const chgTypeExisted = chargeTypeDropdownOption?.find(chgType =>
                        chgType.value === chgTypeEty.chargeType);
                    if (!chgTypeExisted) {
                        chargeTypeDropdownOption.push({
                            dropdownLabel: chgTypeEty.chargeType,
                            tagLabel: chgTypeEty.chargeType,
                            value: chgTypeEty.chargeType
                        })
                    }
                    if (chgTypeEty.subChargeType) {
                        if (!subChargeTypeDropdownOption[chgTypeEty.chargeType]) {
                            subChargeTypeDropdownOption[chgTypeEty.chargeType] = [];
                        }
                        subChargeTypeDropdownOption[chgTypeEty.chargeType].push({
                            dropdownLabel: chgTypeEty.subChargeType,
                            tagLabel: chgTypeEty.subChargeType,
                            value: chgTypeEty.subChargeType
                        });
                    }
                });

                recalProcessAndGenDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        chargeTypeDropdownOptions: chargeTypeDropdownOption,
                        subChargeTypeDropdownOptions: subChargeTypeDropdownOption
                    }
                }))
            }
        )

        await companyRepo.getAllCompanyForCombobox().then(
            companies => {
                let newCompanies = companies?.filter(company => company.companyType !== 'MASTER' && company.companyType !== 'ALLIANCE');

                let companyDropdownOptions = newCompanies?.map((company) => ({
                    dropdownLabel: company.companyCode,
                    tagLabel: company.id.toString(),
                    value: company.companyCode,
                })) ?? []
                companyDropdownOptions = _.orderBy(companyDropdownOptions, "dropdownLabel");

                recalProcessAndGenDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        companyCodeDropdownOptions: companyDropdownOptions
                    }
                }))
            }
        );

        await recalProposalSetRepo.searchAllRecalProposalSetList().then(
            proposalSets => {
                let recalProposalSetDropdownOption = proposalSets?.map((entity) => ({
                    dropdownLabel: entity.proposalSetName ?? "",
                    tagLabel: entity.proposalSetName ?? "",
                    value: entity.proposalSetName ?? "",
                })) ?? []
                let oldRecalProposalSetDropdownOption: DropdownProps[] = [];
                oldRecalProposalSetDropdownOption.push({
                    dropdownLabel: "ORIGINAL",
                    tagLabel: "ORIGINAL",
                    value: "ORIGINAL",
                });

                let newRecalProposalSetDropdownOption: DropdownProps[] = [];
                newRecalProposalSetDropdownOption.push({
                    dropdownLabel: "FINALIZED",
                    tagLabel: "FINALIZED",
                    value: "FINALIZED",
                });
                oldRecalProposalSetDropdownOption = oldRecalProposalSetDropdownOption.concat(recalProposalSetDropdownOption);
                newRecalProposalSetDropdownOption = newRecalProposalSetDropdownOption.concat(recalProposalSetDropdownOption);

                recalProcessAndGenDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        oldRecalProposalSetDropdownOptions: oldRecalProposalSetDropdownOption,
                        newRecalProposalSetDropdownOptions: newRecalProposalSetDropdownOption,
                    }
                }))
            }
        )

    }

    const onSearchCriteriaResetClick = () => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: { ...EMPTY_RECAL_PROCESS_AND_GEN_SEARCH_CRITERIA }
            }
        })
    }

    const onGenCriteriaResetClick = () => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                //generateCriteria: { ...EMPTY_RECAL_PROCESS_AND_GEN_GENERATE_CRITERIA },
                generateCriteria: {
                    ...EMPTY_RECAL_PROCESS_AND_GEN_GENERATE_CRITERIA,
                    consolidationMethod: prevState.generateCriteria.consolidationMethod,
                }
            }
        })
    }

    const onSearchCoVslVoyChange = (inputData: { co?: string, vsl?: string, voy?: string }, fieldName: { co: string, vsl: string, voy: string }) => {
        let coVal: string = "";
        let vslVal: string = "";
        let voyVal: string = "";
        if (inputData?.co) {
            coVal = inputData?.co.toUpperCase().replace(/\s+/g, '');
        }
        if (inputData?.vsl) {
            vslVal = inputData?.vsl.toUpperCase().replace(/\s+/g, '');
        }
        if (inputData?.voy) {
            voyVal = inputData?.voy.toUpperCase();
        }

        recalProcessAndGenDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldName.co]: coVal,
                [fieldName.vsl]: vslVal,
                [fieldName.voy]: voyVal,
            }
        }))
    }

    const onSearchFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (fieldKey === 'chargeType') {
            recalProcessAndGenDispatch(prevState => {
                return {
                    ...prevState,
                    searchCriteria: {
                        ...prevState.searchCriteria,
                        subChargeType: val === prevState.searchCriteria.chargeType ? prevState.searchCriteria.subChargeType : ''
                    },
                }
            })
        }
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        return recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: val
                },
            }
        });
    }
    const onBulkEditFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        return recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                [fieldKey]: val
            }
        });
    }

    const onGenerateFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        return recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                generateCriteria: {
                    ...prevState.generateCriteria,
                    [fieldKey]: val
                },
            }
        });
    }

    const onEditFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;

        return recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                currentSubmitEditRow: {
                    ...prevState.currentSubmitEditRow,
                    [fieldKey]: val
                },
            }
        });
    }

    const onSearchDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        recalProcessAndGenDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            },
        }))
    }

    const onGenDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        recalProcessAndGenDispatch(prevState => ({
            ...prevState,
            generateCriteria: {
                ...prevState.generateCriteria,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            },
        }))
    }

    const onShowLoading = () => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                isLoading: true,
            }
        })
    }

    const onHideLoading = () => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                isLoading: false,
            }
        })
    }

    const onGenerate = async (criteria: RecalProcessAndGenGenerateCriteria, countryCode: string | null, companyCode: string | null) => {
        criteria = {
            ...criteria,
            countryCode: countryCode,
            revenueCompanyCode: companyCode
        }
        return await recalProcessAndGenRepo.recalculationGenerate(criteria);
    }

    const onSubmit = async (rows: RecalProcessAndGenSubmitEntity[]) => {
        return await recalProcessAndGenRepo.recalculationSubmit(rows);
    }

    const onDelete = async (rows: RecalProcessAndGenEntity[]) => {
        return await recalProcessAndGenRepo.recalculationDelete(rows);
    }

    const updateSelectedRows = async (rows: RecalProcessAndGenEntity[]) => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                selectRows: rows,
                forceRefresh: !prevState.forceRefresh
            }
        })
    }
    const updateSelectedSubmitRows = async (rows: RecalProcessAndGenSubmitEntity[]) => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                selectSubmitRows: rows,
            }
        })
    }
    const onSearchClick = async () => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                isShowCriteriaPanel: !prevState.isShowCriteriaPanel,
            }
        })
    }
    const onGenerateClick = async () => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                isShowGeneratePanel: true,
                isShowCriteriaPanel: false,
                generateCriteria: {
                    ...EMPTY_RECAL_PROCESS_AND_GEN_GENERATE_CRITERIA,
                    consolidationMethod: 'SEQ',
                },
            }
        })
    }
    const groupEntities = (rows: RecalProcessAndGenEntity[]): RecalProcessAndGenSubmitEntity[] => {
        const groupedMap = new Map<string, RecalProcessAndGenSubmitEntity>();
        for (const row of rows) {
            const { billToCompany, id } = row;
            const groupKey = billToCompany ?? '*';

            if (!groupedMap.has(groupKey)) {
                groupedMap.set(groupKey, {
                    billToCompany: groupKey,
                    idList: [],
                });
            }
            groupedMap.get(groupKey)!.idList.push(id);
        }
        return Array.from(groupedMap.values());
    }

    const onSubmitClick = async (rows: RecalProcessAndGenEntity[], isSubmitAll: boolean) => {
        const result = groupEntities(rows);

        recalProcessAndGenDispatch(prevState => {
            const entityList = result.map(item => ({
                ...item,
                oldTariff: prevState.dynamicOptions.oldRecalProposalSetDropdownOptions[0].value,
                newTariff: prevState.dynamicOptions.newRecalProposalSetDropdownOptions[0].value,
            }));
            return {
                ...prevState,
                isSubmitAll: isSubmitAll,
                isShowSubmitPanel: true,
                isShowCriteriaPanel: false,
                recalProcessAndGenSubmitList: entityList,
            }
        })
    }

    const onCloseSubmitPanel = () => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                isShowSubmitPanel: false
            }
        });
    };
    const onSearch = async (searchCriteria: RecalProcessAndGenSearchCriteria) => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                recalProcessAndGenList: [],
                selectRows: [],
                searchCriteria: searchCriteria,
                isShowEditPanel: false,
                isShowGeneratePanel: false,
                isShowSubmitEditPanel: false,
                isShowSubmitPanel: false,
            }
        });

        await recalProcessAndGenRepo.onSearch(searchCriteria).then((data) => {
            recalProcessAndGenDispatch(prevState => {
                return {
                    ...prevState,
                    recalProcessAndGenList: data,
                }
            });
        });
    }

    const onGenerateRadioChange = (e: any, fieldName: string) => {
        if (e.checked) {
            recalProcessAndGenDispatch(prevState => {
                return {
                    ...prevState,
                    generateCriteria: {
                        ...prevState.generateCriteria,
                        [fieldName]: e.key,
                        revenueAccountCode: null,
                        revenueCompanyCode: null,
                        intercompanyCode: null,
                        salesChannelCode: null,
                        spareCode: null,
                        productServiceCode: null,
                        projectCode: null,
                        costCentreCode: null,
                        countryCode: null,
                        desc1: null,
                        desc2: null,
                    },
                }
            });
        }
    };

    const onCloseGeneratePanel = () => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                isShowGeneratePanel: false
            }
        });
    };
    const onEditSubmitPanel = (row: RecalProcessAndGenSubmitEntity) => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                isShowSubmitEditPanel: true,
                currentSubmitEditRow: row,
                currentSubmitRow: row,
            }
        });
    };

    const onCloseSubmitEditPanel = () => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                isShowSubmitEditPanel: false
            }
        });
    };
    const onCloseEditPanel = () => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                isShowEditPanel: false,
                oneOffRate: null,
                seqNo: null
            }
        });
    };

    const onEditPanelClick = (isAssignSeq: boolean) => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                isShowEditPanel: true,
                isAssignSeq: isAssignSeq,
                isShowCriteriaPanel: false,
            }
        });
    };

    const onResetSubmitEditPanel = () => {
        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                currentSubmitEditRow: prevState.currentSubmitRow
            }
        });
    };

    const onSaveSubmitEditRow = (row: RecalProcessAndGenSubmitEntity) => {
        recalProcessAndGenDispatch(prevState => {
            const newRows = prevState.recalProcessAndGenSubmitList.map(item => item.billToCompany === row.billToCompany ? row : item);
            return {
                ...prevState,
                recalProcessAndGenSubmitList: newRows,
                isShowSubmitEditPanel: false
            }
        });
    };

    const onSaveClick = async (isAssignSeq: boolean, seqNo: number | null, oneOffRate: number | null, rows: RecalProcessAndGenEntity[]) => {

        recalProcessAndGenDispatch(prevState => {
            return {
                ...prevState,
                recalProcessAndGenList: [],
                selectRows: [],
            }
        });

        let criteria = { ...EMPTY_RECAL_PROCESS_AND_GEN_EDIT_CRITERIA };
        criteria = {
            ...criteria,
            selectRows: rows,
            isAssignOneOffRate: !isAssignSeq,
            isAssignSeq: isAssignSeq,
            oneOffRate: oneOffRate,
            seqNo: seqNo,
        }
        await recalProcessAndGenRepo.onSave(criteria).then((data) => {
            recalProcessAndGenDispatch(prevState => {
                return {
                    ...prevState,
                    isShowEditPanel: false,
                    oneOffRate: null,
                    seqNo: null
                }
            });
        });
    };

    return {
        onCloseGeneratePanel: onCloseGeneratePanel,
        onSearch: onSearch,
        onSearchCoVslVoyChange: onSearchCoVslVoyChange,
        onSearchClick: onSearchClick,
        loadDropdownOption: loadDropdownOption,
        onSearchCriteriaResetClick: onSearchCriteriaResetClick,
        updateSelectedRows: updateSelectedRows,
        onSearchFieldChange: onSearchFieldChange,
        onSearchDateRangeChange: onSearchDateRangeChange,
        onShowLoading: onShowLoading,
        onHideLoading: onHideLoading,
        onSubmit: onSubmit,
        onGenerate: onGenerate,
        onGenerateFieldChange: onGenerateFieldChange,
        onGenerateRadioChange: onGenerateRadioChange,
        onGenerateClick: onGenerateClick,
        updateSelectedSubmitRows: updateSelectedSubmitRows,
        onSubmitClick: onSubmitClick,
        onEditSubmitPanel: onEditSubmitPanel,
        onCloseSubmitPanel: onCloseSubmitPanel,
        onCloseSubmitEditPanel: onCloseSubmitEditPanel,
        onEditFieldChange: onEditFieldChange,
        onDelete: onDelete,
        onResetSubmitEditPanel: onResetSubmitEditPanel,
        onSaveSubmitEditRow: onSaveSubmitEditRow,
        onCloseEditPanel: onCloseEditPanel,
        onEditPanelClick: onEditPanelClick,
        onBulkEditFieldChange: onBulkEditFieldChange,
        onSaveClick: onSaveClick,
        onGenCriteriaResetClick: onGenCriteriaResetClick,
        onGenDateRangeChange: onGenDateRangeChange
    }
}